// extracted by mini-css-extract-plugin
export default {"featuredPosts":"FeaturedPosts-module--featuredPosts--gSXW0","posts":"FeaturedPosts-module--posts--kMmIz"};